<template>
  <div class="p-2">
    <div
      class="rounded border-8 p-0 cursor-pointer item-article p-2 border shadow-sm bg-fakeProduct"
    >
      <div
        class="image img-squared img-thumbnail border-0 bg-fakeImage mx-auto"
        style="height:18em;width: 18em"
      ></div>
      <hr />
      <p class="text-center pt-5 text-dark bg-fakeImage">&nbsp;</p>
      <h5 class="text-danger-2 pt-4 text-center font-weight-bold bg-fakeImage">&nbsp;</h5>
    </div>
  </div>
</template>

<script>
export default {
  name: "Product",
  data() {
    return {};
  }
};
</script>

<style lang="sass">
.item-menu-category
    padding-left: 0px
    padding-right: 5px
    transition: 0.2s
    &:hover
        color: #d31a00
        padding-left: 5px
        padding-right: 0px

.text-danger-2
    color: #d31a00

.bg-danger-2
    background-color: #d31a00

.bg-light-2
    background-color: #f6f6f5

.item-article
    transition: .1s
    &:hover
        box-shadow: 0 .5rem 1rem rgba(0,0,0,.15)!important

.bg-fakeProduct
    background-color: #EAEAEA
.bg-fakeImage 
    background-color: #DBDBDB
    animation: fadein 2s infinite

@keyframes fadein 
    0%
        opacity: 1
    50% 
        opacity: .5
    100%
        opacity: 1

</style>